export class LookupFilter {
    filterXml: string = '';
    entityLogicalName: string = '';

    constructor(filterXml: string, entityLogicalName: string) {
        this.filterXml = filterXml;
        this.entityLogicalName = entityLogicalName;
    }
}
